import { useMemo } from 'react';

const chunkArray = (myArray, size) => {
  const results = [];

  while (myArray.length) {
    results.push(myArray.splice(0, size));
  }

  return results;
};

const useParagraphSplit = ({ data, splitLimit, wordLimit, splitParagraph }) => {
  const paragraph = useMemo(() => {
    if (data && splitLimit) {
      const splitData = data.split(' ');
      const chunked = chunkArray(
        splitData,
        Math.ceil(splitData.length / splitLimit)
      ).reduce((aggregate, item) => {
        return aggregate.concat(item.join(' '));
      }, []);
      return chunked;
    }
    if (data && wordLimit) {
      const splitData = data.split(' ');
      const chunked = chunkArray(splitData, Math.ceil(wordLimit)).reduce(
        (aggregate, item) => {
          return aggregate.concat(item.join(' '));
        },
        []
      );
      return chunked;
    }
    if (data && splitParagraph) {
      const splitData = data.split('<br><br>');
      const chunked = chunkArray(
        splitData,
        Math.ceil(splitData.length / splitParagraph)
      ).reduce((aggregate, item) => {
        return aggregate.concat(item.join('<br><br>'));
      }, []);
      return chunked;
    }
    return [data];
  }, [data, splitLimit, wordLimit, splitParagraph]);

  return paragraph;
};

export default useParagraphSplit;
